@if (isMenuLayout()) {
  <p-button
    label="Help & support"
    variant="text"
    severity="contrast"
    styleClass="w-full !justify-start"
    (onClick)="onMenuButtonClick($event)"
  >
    <svg-icon src="assets/icons/general/question-mark-circle.svg" />
  </p-button>
}

@if (isStandaloneLayout()) {
  <div class="relative">
    <!-- popover target highlight -->
    @if (showFirstTimePopover()) {
      <div
        class="absolute inset-0 animate-pulse rounded outline outline-2 outline-border-common-highlighter"
      ></div>
    }
    <p-button
      size="small"
      pTooltip="Support"
      tooltipPosition="left"
      (onClick)="onMenuButtonClick($event)"
    >
      <ng-template #icon>
        <svg-icon src="assets/icons/general/question-mark-circle.svg" />
      </ng-template>
    </p-button>
  </div>
}

<p-popover #supportMenuPopover styleClass="[&_.p-popover-content]:!p-0">
  <div class="flex flex-col gap-1 p-1">
    <h3
      class="typography-headings-x-small px-1.5 py-3 text-text-common-contrast"
    >
      How can we help you today?
    </h3>

    <p-button
      label="Log a support ticket"
      severity="contrast"
      variant="text"
      styleClass="!w-full !justify-start"
      (onClick)="openSupportTicket()"
    >
      <svg-icon
        class="text-text-common-primary"
        src="/assets/icons/general/action-lifeboat.svg"
      />
    </p-button>
    <p-button
      label="Support documentation"
      severity="contrast"
      variant="text"
      styleClass="!w-full !justify-start"
      (onClick)="openSupportDocs()"
    >
      <svg-icon
        class="text-text-common-primary"
        src="/assets/icons/general/communication-book.svg"
      />
    </p-button>
  </div>
</p-popover>

<!-- used to display a first time tooltip to the user to guide them on this feature -->
<p-popover
  #firstTimePopover
  [dismissable]="false"
  styleClass="[--p-popover-border-color:theme(colors.interface-common.contrast)] [--p-popover-background:theme(colors.interface-common.contrast)] p-popover--with-arrow"
>
  <ng-template #content>
    <div class="flex flex-col gap-3 p-1 text-white">
      <div class="flex items-center gap-2">
        <svg-icon src="assets/icons/general/system-feedback-sparkles.svg" />
        <p>Find help docs and log a support ticket here.</p>
      </div>
      <p-button
        (click)="dismissFirstTimePopover()"
        label="Got it!"
        size="small"
      />
    </div>
  </ng-template>
</p-popover>
